import http from "../http-common";

const getAll = loc => {
    return http.get(`/v1/locations/`);
};

const getAllDeleted = loc => {
    return http.get(`/v1/locations/deleted/`);
};

const get = id => {
    return http.get(`/v1/locations/${id}`);
};

const create = data => {
    return http.post("/v1/locations", data);
};

const update = (id, data) => {
    return http.put(`/v1/locations/${id}`, data);
};

const remove = id => {
    return http.delete(`/v1/locations/${id}`);
};

const removeAll = () => {
    return http.delete(`/v1/locations`);
};

const findByName = name => {
    return http.get(`/v1/locations?name=${name}`);
};

export default {
    getAll,
    getAllDeleted,
    get,
    create,
    update,
    remove,
    removeAll,
    findByName
};